import React, { Fragment } from 'react';
import { Button, Grid, Header, Icon, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import SearchTableData from '../../util/SearchTableData';
import { ExportReactCSV } from '../../util/ExportCSV';
import PaginationFront from '../../util/PaginationFront';
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p><FormattedMessage id="professorInputGrades.noCoursesMessage" /></p>;
const NoDataMessageSS = () => <p><FormattedMessage id="professorInputGrades.noCoursesMessageSS" /></p>;
const NoFilterDataMessage = () => <p><FormattedMessage id="professorInputGrades.noCoursesFilter" /></p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class CourseByYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            professor: localStorage.getItem('activeRole') ? localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' || localStorage.getItem('activeRole').substr(0, 8) === 'Asistent' : false,

            activeIndex: 0,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: []
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        else{
            return this.props.coursesByYear;

        }
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const headersForExport = [
            { label: 'Naziv predmeta (B/H/S jezik)', key: 'courseImplementationName' },
            { label: 'Naziv predmeta (Engleski jezik)', key: 'courseNameEnglish' },
            { label: 'Semestar', key: 'semesterName' },
            { label: 'Napomena', key: 'courseComment' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Naziv predmeta (B/H/S jezik)', width: { wpx: 400 } },
                    { title: 'Naziv predmeta (Engleski jezik)', width: { wpx: 400 } },
                    { title: 'Semestar', width: { wpx: 200 } },
                    { title: 'Napomena', width: { wpx: 200 } },
                ],
                data: this.props.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        return (

            currentPosts.length ?
                <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' ? 16 : 13} >
                                <Grid columns={2} stackable>

                                    <Grid.Column width={14}>
                                        <SearchTableData profMozilla data={this.props.coursesByYear} getResults={this.getResults} filterItem={['courseImplementationName', 'courseNameEnglish', 'semesterName']} />
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign={'center'}>
                                        <ExcelFile filename="Spisak predmeta" element={<Popup
                                            trigger={<Button animated="vertical" disabled={this.props.coursesByYear.length === 0} color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi spisak u Excel-u"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={multiDataSet} name="Predmeti" />
                                        </ExcelFile>
                                        {/*<ExportReactCSV  color="green" disabled={this.props.coursesByYear.length === 0} fluid csvData={this.props.coursesByYear} headers={headersForExport} fileName="Spisak predmeta" />*/}
                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={1}><FormattedMessage id="common.ordinal" /></Table.HeaderCell>
                            <Table.HeaderCell colSpan={5}>
                                <Header as="h4" image>
                                    <Header.Content>
                                        <FormattedMessage id="common.courseName" />
                                        <Header.Subheader> <FormattedMessage id="common.bosnian" /></Header.Subheader>
                                    </Header.Content>
                                </Header>

                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={5}>
                                <Header as="h4" image>
                                    <Header.Content>
                                        <FormattedMessage id="common.courseName" />
                                        <Header.Subheader> <FormattedMessage id="common.english" /></Header.Subheader>
                                    </Header.Content>
                                </Header>

                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>
                                <FormattedMessage id="common.courseRoleType" />
                            </Table.HeaderCell>

                            {localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && <Table.HeaderCell colSpan={3} />}

                        </Table.Row>
                    </Table.Header>
                    <Table.Body> {currentPosts.sort((a, b) => b.semesterId - a.semesterId).map((el, index) =>
                        (<Table.Row key={index}>
                            <Table.Cell verticalAlign="middle" width={1}>
                                {(index + 1)}.
                            </Table.Cell >
                            <Table.Cell verticalAlign="middle" colSpan="5">
                                <Grid columns={1} centered className="stackable">
                                    <Grid.Row verticalAlign="middle">
                                        <Grid.Column width="10">
                                            <span >  {el.semesterName === 'zimski semestar' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseImplementationName}</span>
                                        </Grid.Column>
                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                <span style={{ color: '#a6a4a1' }}>{el.courseComment ? el.courseComment && (el.comment || el.commentForStaff || el.comment) ? el.courseComment + ' / '  : el.comment : ''}{el.comment ? el.commentForStaff ? el.comment + ' / ' + el.commentForStaff : el.comment : el.commentForStaff ? el.commentForStaff : '' }</span>
                                            {/*<span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>*/}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={5}>
                                {el.courseNameEnglish}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                {el.courseRoleTypeName}
                            </Table.Cell>

                            {localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && <Table.Cell textAlign="center" verticalAlign="middle" colSpan={3}>
                                { this.state.professor ?
                                    <Fragment> <FormattedMessage id="route.courseDetails">
                                        {(msg) => (
                                            <Link to={{ pathname: msg, state: { courseImplementationName: el.courseImplementationName, courseImplementationId: el.courseImplementationId } }}>
                                                <Popup
                                                    content={<FormattedMessage id="common.details" />}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="align justify"
                                                            size="small"
                                                            color="blue"
                                                            onClick={() => {
                                                                localStorage.setItem('courseComment', el.courseComment);
                                                            }}
                                                        >
                                                        </Button>
                                                    }
                                                />

                                            </Link>

                                        )}
                                    </FormattedMessage>
                                        <FormattedMessage id="route.courseStudents">
                                        {(msg) => (
                                                <Link to={{ pathname: msg, state: { courseImplementationName: el.courseImplementationName, courseImplementationId: el.courseImplementationId, employeeId: el.employeeId } }}>
                                                <Popup
                                                    content={<FormattedMessage id="common.students" />}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="group"
                                                            size="small"
                                                            color="blue"
                                                            onClick={() => {
                                                                localStorage.setItem('courseComment', el.courseComment);
                                                            }}
                                                        >
                                                        </Button>
                                                    }
                                                    />
                                            </Link>)
                                        }
                                    </FormattedMessage>
                                    </Fragment>
                                    : (localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu') &&
                                    <Fragment>
                                        <Link to={{ pathname: '/nastavno-osoblje/predmeti/detalji', state: { courseImplementationName: el.courseImplementationName, courseImplementationId: el.courseImplementationId } }}>
                                            <Popup
                                                content={<FormattedMessage id="common.details" />}
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="align justify"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => {
                                                            localStorage.setItem('courseComment', el.courseComment);
                                                        }}
                                                    >
                                                    </Button>
                                                }
                                            />

                                        </Link>
                                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&<Link to={{ pathname: '/nastavno-osoblje/predmeti/studenti', state: { courseImplementationName: el.courseImplementationName, courseImplementationId: el.courseImplementationId, employeeId: el.employeeId } }}>
                                            <Popup
                                                content={<FormattedMessage id="common.students" />}
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="group"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => {
                                                            localStorage.setItem('courseComment', el.courseComment);
                                                        }}
                                                    >
                                                    </Button>
                                                }
                                            />
                                        </Link>}
                                    </Fragment>
                                }

                                {this.state.professor ?
                                    <FormattedMessage id="route.courseStatistic">
                                        {(msg) => (<Link to={{
                                            pathname: msg,
                                            state: {
                                                courseImplementationName: el.courseImplementationName,
                                                courseImplementationId: el.courseImplementationId,
                                                academicYear: this.props.academicYearId,
                                                semester: el.semesterId
                                            }
                                        }}
                                        >
                                            <Popup
                                                content={<FormattedMessage id="statistics.statistic" />}
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="chart bar"
                                                        size="small"
                                                        color="teal"
                                                    >
                                                    </Button>
                                                }
                                            /></Link>)}
                                    </FormattedMessage>
                                    : (localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu') && <Link to={{
                                        pathname: '/nastavno-osoblje/predmeti/statistika',
                                        state: {
                                            courseImplementationName: el.courseImplementationName,
                                            courseImplementationId: el.courseImplementationId,
                                            academicYear: this.props.academicYearId,
                                            semester: el.semesterId
                                        }
                                    }}
                                    >
                                        <Popup
                                            content={<FormattedMessage id="statistics.statistic" />}
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="chart bar"
                                                    size="small"
                                                    color="teal"
                                                >
                                                </Button>
                                            }
                                        /></Link>}
                            </Table.Cell>}
                        </Table.Row>))}
                    </Table.Body>
                    <ToastContainer hideProgressBar />
                </Table>

                : this.state.showFiltersOnButton ?
                    <NoFilterDataMessage />
                    : this.state.professor !== false ?
                        <NoDataMessage />
                        : <NoDataMessageSS />


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/Courses/CoursesByYear.js